export default "__VITE_ASSET__a45bfb9b__"